module.exports = __webpack_public_path__ + "img/img_brand24.f002dc47.jpg";